export const FOOTER_PROMO_ONLY_PATHS = Object.freeze([
  '/daily',
  '/unlimited',
  '/riddled-in',
  '/generations',
  '/earth',
]);

const normalizePathname = (pathname) => {
  if (typeof pathname !== 'string') return '';
  if (pathname.length > 1 && pathname.endsWith('/')) {
    return pathname.slice(0, -1);
  }
  return pathname;
};

export const shouldShowPromoOnlyFooter = (pathname) =>
  FOOTER_PROMO_ONLY_PATHS.includes(normalizePathname(pathname));
